/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StatusCodeValueRawMilk } from './statusCodeValueRawMilk';
import { StatusCodeValueTotalDischarges } from './statusCodeValueTotalDischarges';
import { StatusCodeValuePartialDischarges } from './statusCodeValuePartialDischarges';
import { StatusCodeValueEnergyConsumptionCip } from './statusCodeValueEnergyConsumptionCip';
import { StatusCodeValueTimeUse } from './statusCodeValueTimeUse';
import { TimeCategory } from './timeCategory';
import { StatusCodeValueEnergyConsumptionProductionKWhPerH } from './statusCodeValueEnergyConsumptionProductionKWhPerH';
import { StatusCodeValueWaterCirculationTime } from './statusCodeValueWaterCirculationTime';
import { StatusCodeValueNumberOfCips } from './statusCodeValueNumberOfCips';
import { AveragePowerConsumption } from './averagePowerConsumption';
import { StatusCodeValueEnergyConsumptionProductionKWherM3 } from './statusCodeValueEnergyConsumptionProductionKWherM3';
import { StatusCodeValueEnergyConsumptionProductionTotal } from './statusCodeValueEnergyConsumptionProductionTotal';
import { StatusCodeValueWhPerLiterLiquid } from './statusCodeValueWhPerLiterLiquid';


export interface DairyAllInOneResponseDTO { 
    rawmilk?: StatusCodeValueRawMilk;
    time_use?: StatusCodeValueTimeUse;
    time_utilization?: TimeCategory;
    average_power_consumption?: Array<AveragePowerConsumption>;
    energy_consumption_production_total?: StatusCodeValueEnergyConsumptionProductionTotal;
    energy_consumption_production_kwh_per_m3?: StatusCodeValueEnergyConsumptionProductionKWherM3;
    energy_consumption_production_kwh_per_h?: StatusCodeValueEnergyConsumptionProductionKWhPerH;
    wh_per_liter_liquid?: StatusCodeValueWhPerLiterLiquid;
    partial_discharges?: StatusCodeValuePartialDischarges;
    total_discharges?: StatusCodeValueTotalDischarges;
    energy_consumption_cip?: StatusCodeValueEnergyConsumptionCip;
    number_of_cips?: StatusCodeValueNumberOfCips;
    water_circulation_time?: StatusCodeValueWaterCirculationTime;
}

